import { AxiosInstance } from 'axios';
import { IItem } from 'src/views/Admin/Items/types';
import { toResponse } from '../../genericToResponse';

export default (api: AxiosInstance, url: string) => async (
  item: IItem,
  withWarnings = false
) => {
  const urlWithWarningParam = withWarnings
    ? `${url}?confirmedWarnings=true`
    : url;
  const response = await api.post(urlWithWarningParam, item);
  return toResponse(response.data) as IItem;
};



// WEBPACK FOOTER //
// ./src/services/api/admin/items/add.ts